import React from 'react'

import Main360Desktop from './desktop/main360screenDesktop.Component'

import { apacheData } from './../data/apache/data'
import { kingData } from './../data/king/data'
import { neoData } from './../data/neo/data'
import { ntorqData } from './../data/ntorq/data'
import { sportData } from './../data/sport/data'
import { strykerData } from './../data/stryker/data'
import { maxData } from './../data/max/data'
import { raiderData } from '../data/raider/data'

import handleOpenFullScreen from './../utils/fullscreen'
import Main360Mobile from './mobile/main360screenMobile.Component'

import { recorridoData as RData } from '../data/recorrido.data'
import { recorridoData as RMData } from '../data/recorridoMobile.data'
import { indData as IData} from '../data/individual.data'
import { colorData } from '../data/colors.data'
import mobileAndTabletCheck from '../utils/mobileCheck'

import song from './../assets/song.mp3'

interface Props{
    isMobile: boolean
}

interface State{
    isMenuOpened: boolean
    isFullScreen: boolean,
    isMuted: boolean,
    isFamilias: boolean,
    isFamiliaSelected: boolean,
    selectedBikeFamily: any,
    selectedIndividualBike: boolean
    selectedBike: any,
    currentPanorama: any,
    currentScene: any,
    individualData: any,
    isMultimediaOpened: boolean,
    isSpinOpened: boolean,
    isFichaOpened: boolean,
    isFormularioOpened: boolean,
    isGalleryOpened: boolean,
    currentImage: number,
    currentColor: string,
    currentSet: any,
    currentColorsArray: any,
    currentColorIndex: number,
    fullFicha: boolean,
    isLocalMobile: boolean,
    currentBulletImage: string,
    currentBulletText: string,
    openBullet: boolean,
    openRedirectionBar: boolean
}

class Bridge extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isMenuOpened: false,
            isFullScreen: false,
            isMuted: false,
            isFamilias: true,
            isFamiliaSelected: false,
            selectedBikeFamily: {},
            selectedIndividualBike: false,
            selectedBike: {},
            currentPanorama:"",
            currentScene: mobileAndTabletCheck() ? RMData()[0]["START"]:RData()[0]["START"],
            individualData: IData()[0],
            isMultimediaOpened: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: false,
            isGalleryOpened: false,
            currentImage: -1,
            currentColor: "",
            currentSet: [],
            currentColorsArray: [],
            currentColorIndex: -1 ,
            fullFicha: false,
            isLocalMobile: false,
            currentBulletImage: "",
            currentBulletText: "",
            openBullet: false,
            openRedirectionBar: true
        }
    }

    componentDidMount(){
        let audio = document.getElementById("song") as HTMLAudioElement
        if(audio){
            audio.volume = 0.5
        }
        this.setState({
            isLocalMobile: mobileAndTabletCheck()
        })

    }

    handleToogleMenu = () => {
        this.setState({
            isMenuOpened: !this.state.isMenuOpened
        })
    }

    handleFullScreen = () => {
        this.setState({
            isFullScreen: !this.state.isFullScreen
        })
        handleOpenFullScreen(this.state.isFullScreen)
    }

    handleAudio = () => {
        this.setState({
            isMuted: !this.state.isMuted
        })
    }
    
    handleFamilyBtnClick = (payload: any) => {
        let motosData: any = {
            "TVS APACHE": apacheData(),
            "TVS SPORT": sportData(),
            "STRYKER": strykerData(),
            "TVS MAX": maxData(),
            "TVS NTORQ": ntorqData(),
            "TVS NEO NX": neoData(),
            "TVS KING": kingData(),
            "TVS RAIDER": raiderData()
        }
        this.setState({
            isFamilias: false,
            isFamiliaSelected: true,
            selectedBikeFamily: motosData[payload][0]
        })
    }

    handleBikeBtnClick = (payload: any) => {
        this.setState({
            isMenuOpened: false,
            selectedBike: payload,
            selectedIndividualBike: true,
            currentScene: this.state.isLocalMobile ? RMData()[0][payload.Nombre]:RData()[0][payload.Nombre],
            isMultimediaOpened: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: false,
            isGalleryOpened: false,
            currentImage: -1,
            currentColor: "",
            currentColorsArray: [],
            currentColorIndex: -1,
            currentSet: [],
            openBullet: false
        })
    }

    handleMotoMes = (payload: any) => {
        this.setState({
            selectedBike: IData()[0]["MOTO MES"],
            currentScene: this.state.isLocalMobile ? RMData()[0]["MOTO MES"]:RData()[0]["MOTO MES"],
            isMenuOpened: false,
            selectedIndividualBike: true,
            isMultimediaOpened: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: false,
            isGalleryOpened: false,
            currentImage: -1,
            currentColor: "",
            currentColorsArray: [],
            currentColorIndex: -1,
            currentSet: [],
            openBullet: false
        })
    }

    handleBackBtn = () => {
        this.setState({
            isFamilias: true,
            isFamiliaSelected: false,
            selectedBikeFamily: {}
        })
    }

    handleOpenMultimedia = (payload: boolean) => {
        this.setState({
            isMultimediaOpened: payload,
            openRedirectionBar: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: false,
            isGalleryOpened: payload === false ? false: this.state.isGalleryOpened,
            currentImage: payload === false ? -1: this.state.currentImage,
        })
    }

    handleOpenSpin = () => {
        this.setState({
            isMultimediaOpened: false,
            isSpinOpened: true,
            isFichaOpened: false,
            isFormularioOpened: false,
            currentColor: colorData()[0][this.state.selectedBike.Nombre].Colors[0].name,
            currentColorsArray: colorData()[0][this.state.selectedBike.Nombre].Colors,
            currentColorIndex: 0
        })
    }

    handleChangeColors = (index) => {
        this.setState({
            isMultimediaOpened: false,
            isSpinOpened: true,
            isFichaOpened: false,
            isFormularioOpened: false,
            currentSet: [],
            currentColor: colorData()[0][this.state.selectedBike.Nombre].Colors[index].name,
            currentColorsArray: colorData()[0][this.state.selectedBike.Nombre].Colors,
            currentColorIndex: index
        })
    }

    handleCloseSpin = () => {
        this.setState({
            isMultimediaOpened: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: false,
            currentColor: "",
            currentColorsArray: [],
            currentColorIndex: -1
        }, () => {
            this.setState({
                currentSet: []
            })
        })
    }

    handleOpenFichaTecnica = (payload: boolean) => {
        this.setState({
            isMultimediaOpened: false,
            openRedirectionBar: false,
            isSpinOpened: false,
            isFichaOpened: payload,
            isFormularioOpened: false,
            isGalleryOpened: false
        })

        if(!payload){
            this.handleOpenFichaOnline(payload)
        }
    }

    handleOpenFormulario = (payload) => {
        this.setState({
            isMultimediaOpened: false,
            isSpinOpened: false,
            isFichaOpened: false,
            isFormularioOpened: payload,
            isGalleryOpened: false
        })
    }

    handlePanoUpdate = (payload: any) => {
        console.log(payload.includes)
        this.setState({
            currentPanorama: payload,
            isMultimediaOpened: false,
            isFichaOpened: false,
            currentScene: RData()[0][payload],
            openRedirectionBar:payload.includes("FAMILIA") ||
            payload.includes("START") ||
            payload.includes("GENERAL") ? false:true,
            selectedBike: 
                payload.includes("FAMILIA") ||
                payload.includes("START") ||
                payload.includes("GENERAL") ? "":
                this.state.individualData[payload] 
                ? this.state.individualData[payload]: this.state.selectedBike,
            selectedIndividualBike: 
                payload.includes("FAMILIA") ||
                payload.includes("START") ||
                payload.includes("GENERAL")
                ? false:
                this.state.individualData[payload] ? true: this.state.selectedIndividualBike
        })
    }

    handleOpenImage = (payload: boolean,index: number) => {
        console.log(index)
        this.setState({
            isGalleryOpened: payload,
            currentImage: index,
        })
    }

    handleOpenFichaOnline = (payload: boolean) => {
        this.setState({
            fullFicha: payload
        })
    }

    handleOpenBullet = (image: string, text: string) => {
        this.setState({
            openBullet: !this.state.openBullet,
            currentBulletImage: image,
            currentBulletText: text,
            openRedirectionBar:false
        })
    }

    handleOpenRedirection = () => {
        this.setState({
            openRedirectionBar: !this.state.openRedirectionBar
        })
    }

    render(){
        return(
            <React.Fragment>
                <audio autoPlay loop muted={this.state.isMuted} id="song">
                    <source src={song} type="audio/mpeg"/>
                </audio> 
            {
                !this.props.isMobile ?
                <Main360Desktop 
                    handleToogleMenu = {this.handleToogleMenu}
                    isMenuOpened = {this.state.isMenuOpened}
                    isFullScreen = {this.state.isFullScreen}
                    isMuted = {this.state.isMuted}
                    handleFullScreen = {this.handleFullScreen}
                    handleAudio = {this.handleAudio}
                    handleFamilyBtnClick={this.handleFamilyBtnClick}
                    handleBackBtn={this.handleBackBtn}
                    isFamilias={this.state.isFamilias}
                    isFamiliaSelected={this.state.isFamiliaSelected}
                    selectedBikeFamily={this.state.selectedBikeFamily}
                    handleBike={this.handleBikeBtnClick}
                    selectedBike = {this.state.selectedBike}
                    selectedIndividualBike = {this.state.selectedIndividualBike}
                    currentPanorama = {this.state.currentPanorama}
                    currentScene = {this.state.currentScene}
                    handlePanoUpdate = {this.handlePanoUpdate}
                    handleOpenMultimedia = {this.handleOpenMultimedia}
                    handleOpenSpin = {this.handleOpenSpin}
                    handleOpenFichaTecnica = {this.handleOpenFichaTecnica}
                    handleOpenFormulario = {this.handleOpenFormulario}
                    isMultimediaOpened = {this.state.isMultimediaOpened}
                    isSpinOpened = {this.state.isSpinOpened}
                    isFichaOpened = {this.state.isFichaOpened}
                    isFormularioOpened = {this.state.isFormularioOpened}
                    handleOpenImage = {this.handleOpenImage}
                    isGalleryOpened = {this.state.isGalleryOpened}
                    currentImage = {this.state.currentImage}
                    currentColor = {this.state.currentColor}
                    currentSet = {this.state.currentSet}
                    currentColorsArray = {this.state.currentColorsArray}
                    currentColorIndex = {this.state.currentColorIndex}
                    handleChangeColors = {this.handleChangeColors}
                    handleCloseSpin = {this.handleCloseSpin} 
                    isFullFichaOpened = {this.state.fullFicha}
                    handleFullFicha = {this.handleOpenFichaOnline}
                    isMobile = {this.props.isMobile}
                    handleMotoMes = {this.handleMotoMes}
                    handleOpenBullet = {this.handleOpenBullet}
                    currentBulletImage = {this.state.currentBulletImage}
                    currentBulletText = {this.state.currentBulletText}
                    openBullet = {this.state.openBullet}
                    openRedirectionBar = {this.state.openRedirectionBar}
                    handleOpenRedirection = {this.handleOpenRedirection}
                />:
                <Main360Mobile 
                    handleToogleMenu = {this.handleToogleMenu}
                    isMenuOpened = {this.state.isMenuOpened}
                    isFullScreen = {this.state.isFullScreen}
                    isMuted = {this.state.isMuted}
                    handleFullScreen = {this.handleFullScreen}
                    handleAudio = {this.handleAudio}
                    handleFamilyBtnClick={this.handleFamilyBtnClick}
                    handleBackBtn={this.handleBackBtn}
                    isFamilias={this.state.isFamilias}
                    isFamiliaSelected={this.state.isFamiliaSelected}
                    selectedBikeFamily={this.state.selectedBikeFamily}
                    handleBike={this.handleBikeBtnClick}
                    selectedBike = {this.state.selectedBike}
                    selectedIndividualBike = {this.state.selectedIndividualBike}
                    currentPanorama = {this.state.currentPanorama}
                    currentScene = {this.state.currentScene}
                    handlePanoUpdate = {this.handlePanoUpdate}
                    handleOpenMultimedia = {this.handleOpenMultimedia}
                    handleOpenSpin = {this.handleOpenSpin}
                    handleOpenFichaTecnica = {this.handleOpenFichaTecnica}
                    handleOpenFormulario = {this.handleOpenFormulario}
                    isMultimediaOpened = {this.state.isMultimediaOpened}
                    isSpinOpened = {this.state.isSpinOpened}
                    isFichaOpened = {this.state.isFichaOpened}
                    isFormularioOpened = {this.state.isFormularioOpened}
                    handleOpenImage = {this.handleOpenImage}
                    isGalleryOpened = {this.state.isGalleryOpened}
                    currentImage = {this.state.currentImage}
                    currentColor = {this.state.currentColor}
                    currentSet = {this.state.currentSet}
                    currentColorsArray = {this.state.currentColorsArray}
                    currentColorIndex = {this.state.currentColorIndex}
                    handleChangeColors = {this.handleChangeColors}
                    handleCloseSpin = {this.handleCloseSpin} 
                    isFullFichaOpened = {this.state.fullFicha}
                    handleFullFicha = {this.handleOpenFichaOnline}
                    isMobile = {this.props.isMobile}
                    handleMotoMes = {this.handleMotoMes}
                    handleOpenBullet = {this.handleOpenBullet}
                    currentBulletImage = {this.state.currentBulletImage}
                    currentBulletText = {this.state.currentBulletText}
                    openBullet = {this.state.openBullet}
                    openRedirectionBar = {this.state.openRedirectionBar}
                    handleOpenRedirection = {this.handleOpenRedirection}
                />
            }
            </React.Fragment>
        )
    }
}

export default Bridge